module.exports = __webpack_public_path__ + "img/caepia.22be5e33.png";